import { api } from "./configs/axiosConfigs"

export const ProductsAPI = {
    
    getProducts: async (data:any) => {
        const response = await api.get(
            '/product', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getProductsByCompany: async (data:any) => {
        const response = await api.get(
            '/product/listByCompany', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getTypeProducts: async (data:any) => {
        const response = await api.get(
            '/product/types', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getTypesCoin: async (data:any) => {
        const response = await api.get(
            '/product/typescoins', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createProduct: async (data: any) => {
        const response = await api.post(
            '/product/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editProduct: async (idproduct: number, data: any) => {
        const response = await api.post(
            `/product/update/${idproduct}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    
    deleteProduct: async (idproduct: number) => {
        const response = await api.delete(
            `/product/${idproduct}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    downloadTemplate: async () => {
        const response = await api.get(
            '/product/downloadTemplate'
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },

    importProducts: async (data: any) => {
        const response = await api.post(
            '/product/importProductExcel', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },

    exportProducts: async (data: any) => {
        const response = await api.post(
            '/product/exportProductExcel', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },

    updateCostMasive: async (data: any) => {
        const response = await api.post(
            '/product/updateCost', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
}